var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isModalOpen
    ? _c(
        "div",
        {
          ref: "galleryModal",
          staticClass: "gallery-modal",
          class: {
            "is-modern": _vm.galleryVersion === "modern",
            "is-legacy": _vm.galleryVersion === "legacy",
          },
          style: this.defaultModalPosition,
          attrs: { role: "dialog", "aria-modal": "true" },
        },
        [
          _c("div", { staticClass: "gallery-modal__header" }, [
            _vm.galleryVersion == "modern" && _vm.pageWidth > 768
              ? _c("span", {
                  staticClass: "gallery-modal__active-caption",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.displayHtmLChar(_vm.carouselActiveItemMessaging)
                    ),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  ref: "galleryCloseButton",
                  staticClass: "gallery-modal__close-btn",
                  class: { "focus-visible": _vm.galleryVersion == "legacy" },
                  on: { click: _vm.modalClose },
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(_vm._s(_vm.labels.filterCloseButtonText)),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "slickCarousel",
              staticClass: "gallery-modal__carousel",
              class: { "single-item": _vm.getFilteredItems.length == 1 },
            },
            _vm._l(_vm.getFilteredItems, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "gallery-modal__carousel-outer-item",
                  class: { "is-video": item.isVideo },
                  attrs: { "data-modal-carousel-item-id": item.id },
                },
                [
                  item.isVideo
                    ? [
                        _c("figure", [
                          _c(
                            "div",
                            { staticClass: "video-wrapper" },
                            [
                              _c("gallery-video", {
                                key: `video-${item.id}-modal`,
                                attrs: {
                                  "is-priority": item.id === _vm.activeItemId,
                                  item: item,
                                  mode: "full",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          item.caption
                            ? _c("figcaption", {
                                staticClass: "gallery-modal__carousel-caption",
                                class: {
                                  "d-none":
                                    _vm.galleryVersion === "modern" &&
                                    _vm.pageWidth > 768,
                                },
                                attrs: {
                                  "aria-hidden":
                                    _vm.galleryVersion == "modern" &&
                                    _vm.pageWidth > 768,
                                },
                                domProps: {
                                  innerHTML: _vm._s(
                                    `<p>${_vm.displayHtmLChar(
                                      item.caption
                                    )}</p>`
                                  ),
                                },
                              })
                            : _vm._e(),
                        ]),
                      ]
                    : [
                        _c("figure", [
                          item.id === _vm.activeItemId
                            ? _c(
                                "picture",
                                {
                                  attrs: {
                                    "data-type": "full",
                                    "data-clicked-item": "true",
                                  },
                                },
                                [
                                  _c("source", {
                                    attrs: {
                                      media: "(min-width: 1440px)",
                                      srcset: `${item.image}?width=1200`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media:
                                        "(min-width: 1200px) and (max-width: 1439px)",
                                      srcset: `${item.image}?width=1100`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media:
                                        "(min-width: 992px) and (max-width: 1219px)",
                                      srcset: `${item.image}?width=1000`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media:
                                        "(min-width: 768px) and (max-width: 991px)",
                                      srcset: `${item.image}?width=850`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media: "(max-width: 768px)",
                                      srcset: `${item.image}?width=600`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "asset-img",
                                    attrs: {
                                      decoding: "async",
                                      fetchpriority: "high",
                                      src: `${item.image}?width=700`,
                                      width: item.imageWidth,
                                      height: item.imageHeight,
                                      alt: item.imageAlternativeText,
                                      "aria-label": item.imageAlternativeText,
                                    },
                                  }),
                                ]
                              )
                            : _c(
                                "picture",
                                {
                                  attrs: {
                                    "data-type": "full",
                                    "data-clicked-item": "false",
                                  },
                                },
                                [
                                  _c("source", {
                                    attrs: {
                                      media: "(min-width: 1440px)",
                                      "data-srcset-observer": `${item.image}?width=1200`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media:
                                        "(min-width: 1200px) and (max-width: 1439px)",
                                      "data-srcset-observer": `${item.image}?width=1100`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media:
                                        "(min-width: 992px) and (max-width: 1219px)",
                                      "data-srcset-observer": `${item.image}?width=1000`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media:
                                        "(min-width: 768px) and (max-width: 991px)",
                                      "data-srcset-observer": `${item.image}?width=850`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("source", {
                                    attrs: {
                                      media: "(max-width: 768px)",
                                      "data-srcset-observer": `${item.image}?width=600`,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "asset-img",
                                    attrs: {
                                      decoding: "async",
                                      fetchpriority: "low",
                                      src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                                      "data-src-observer": `${item.image}?width=700`,
                                      width: item.imageWidth,
                                      height: item.imageHeight,
                                      alt: item.imageAlternativeText,
                                      "aria-label": item.imageAlternativeText,
                                    },
                                  }),
                                ]
                              ),
                          _vm._v(" "),
                          item.caption
                            ? _c("figcaption", {
                                staticClass: "gallery-modal__carousel-caption",
                                class: {
                                  "d-none":
                                    _vm.galleryVersion === "modern" &&
                                    _vm.pageWidth > 768,
                                },
                                attrs: {
                                  "aria-hidden":
                                    _vm.galleryVersion == "modern" &&
                                    _vm.pageWidth > 768,
                                },
                                domProps: {
                                  innerHTML: _vm._s(
                                    `<p>${_vm.displayHtmLChar(
                                      item.caption
                                    )}</p>`
                                  ),
                                },
                              })
                            : _vm._e(),
                        ]),
                      ],
                ],
                2
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "gallery-modal__announce-text",
              attrs: { "aria-live": "polite" },
            },
            [_vm._v(_vm._s(_vm.carouselActiveItemMessaging))]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }